import * as React from 'react';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import { IFrontState } from '../../frontReducers';
import Body from '../Application/DisplayBody';

export default (props: { store: Store<IFrontState> }) => (
	<Provider store={props.store}>
		<Body />
	</Provider>
);
